export default {
    GET_USER: (state) => {                   // 读取罪犯信息
        if (!state.userInfo) {
            state.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
        }
        return state.userInfo;
    },
    GET_FAMILY: (state) => {                   // 读取登陆人信息
        if (!state.family) {
            if(sessionStorage.getItem('family')){
                state.family = JSON.parse(sessionStorage.getItem('family'));
            }else{
                state.family={
                    name:'请登录',
                    zjhm:''
                }
            }
            
        }
        return state.family;
    },
    GET_TOKEN: (state) => {                   // 读取token
        if (!state.token) {
            state.token = JSON.parse(sessionStorage.getItem('token'));
        }
        return state.token;
        
    },
}


// WEBPACK FOOTER //
// ./src/vuex/getters/getters.js